import React from 'react';

import styled from 'styled-components';

import { showDateNoTime } from '@libs/NwMoment';

import AddressLine from '@components/Addresses/AddressLine';
import FlexContainer from '@components/Gui/FlexContainer';
import { PhoneLine } from '@components/Gui/NwContactInfo';
import NwIcon from '@components/Gui/NwIcon';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

export const EventFieldsTable = styled.table`
    width: 100%;
    tr {
        display: flex;
    }
    td {
        display: flex;
        flex-direction: column;
        flex: 1;
        border-right: ${(props) => props.theme.DefaultBorder};
        padding: 0 1rem;
        text-transform: uppercase;
        font-size: 0.8rem;

        .icon-container {
            padding-right: 1rem;
            svg {
                font-size: 2.4rem;
                margin: 0 0 8px;
            }
        }
        .address-container {
            cursor: pointer;
            margin-bottom: 1rem;
        }
        .arrow-dropdown {
            font-size: 0.95rem;
            margin: 4px 0;
        }
        .label {
            font-size: 0.65rem;
        }
        .date {
            font-size: 0.95rem;
            font-weight: bold;
        }

        &:first-child {
            padding-left: 0;
            flex: unset;
        }
        &:last-child {
            border-right: none;
        }
    }
`;

const ScoutingAccommodationDetails = ({ type, scoutingAccommodationData }) => {
    return (
        <FlexContainer pd="16px 30px 16px 40px">
            <EventFieldsTable>
                <tbody>
                    <tr>
                        <td>
                            <div className="icon-container">
                                <NwIcon
                                    icon={
                                        type === 'RoomLodging'
                                            ? byPrefixAndName.fasl['house-user']
                                            : byPrefixAndName.fasl['bed']
                                    }
                                />
                            </div>
                        </td>
                        <td>
                            {scoutingAccommodationData.Title !== scoutingAccommodationData.Service.Name && (
                                <div>{scoutingAccommodationData.Service.Name}</div>
                            )}
                            <div className="address-container">
                                <AddressLine address={scoutingAccommodationData} twoLines noIcon />
                            </div>
                            {scoutingAccommodationData.PhoneNumber && (
                                <PhoneLine
                                    justify="flex-start"
                                    phoneType="other"
                                    phoneNumber={scoutingAccommodationData.PhoneNumber}
                                    noIcon
                                />
                            )}
                        </td>
                        <td>
                            <div className="label">Check In</div>
                            <FlexContainer>
                                <FlexContainer column alignItems="center">
                                    <div className="date">{showDateNoTime(scoutingAccommodationData.FromDate)}</div>
                                    <NwIcon icon={byPrefixAndName.fasl['arrow-down']} className="arrow-dropdown" />
                                </FlexContainer>
                            </FlexContainer>
                            <div className="label">Check Out</div>
                            <div className="date">{showDateNoTime(scoutingAccommodationData.ToDate)}</div>
                        </td>
                    </tr>
                </tbody>
            </EventFieldsTable>
        </FlexContainer>
    );
};

export default ScoutingAccommodationDetails;
